import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'standardStringFormat'
})
@Injectable({
    providedIn: 'root'
})
export class StandardStringFormatPipe implements PipeTransform {
    transform(value: string | number | Date | null | undefined): string {
        return value != null ? String(value) : 'N/A';
    }
}